<template>
	<div class="tabs">
		<div class="tab-links">
			<template v-for="link in $slots.links()" :key="link.props.target">
				<Component
					@tab:click="onClick"
					:is="link"
					:target="link.props.target"
					:path="path"
					:muted="muted"
					:active="link.props.target === active"
				/>
			</template>
		</div>
		<template v-for="tab in $slots.pane()" :key="tab.props.name">
			<Component
				v-show="tab.props.name === active"
				:is="tab"
				:path="path"
				:name="tab.props.name"
				:muted="muted"
				:active="tab.props.name === active"
			/>
		</template>
	</div>
</template>

<script setup>
import { onMounted } from '@vue/runtime-core'

const props = defineProps({
	active: {
		type: String,
		required: true
	},
	path: {
		type: Array,
		default: () => []
	},
	muted: {
		type: Boolean,
		default: false
	}
})

const emit = defineEmits(['update:active', 'changed', 'changed'])

const onClick = (tab) => {
	emit('update:active', tab)
	emit('changed', tab)
}
onMounted(() => emit('rendered', props.active))
</script>

<style scoped lang="scss">
.tab {
	&-links {
		display: grid;
		grid-auto-columns: minmax(0, 1fr);
		grid-auto-flow: column;
		column-gap: 0.5rem;
	}
}
</style>
